<template>
  <div :class="$style.container">
    <payment-template>
      <base-header
        slot="header"
        :title="$t('operation.denied.title')"
        :language="getLanguage"
      />
      <base-card-template slot="content">
        <img
          slot="image"
          src="@/assets/images/sad-thing.gif"
          :class="$style.image"
          alt="sad-thing"
        />
        <div :class="$style.information">
          <p v-text="$t('rejected.transaction.id.title')"></p>
          <div :class="$style.copy" @click="handleCopy">
            <span>{{ transactionId }}</span>
            <base-icon
              v-m-l="10"
              name="basic_copy"
            />
          </div>
        </div>
        <p>{{ $t('operation.denied.card') }}</p>
        <p v-html="displayMessage"></p>
        <simple-button variant="secondary" @click="handleRedirect">
          {{ $t('try.again') }}
        </simple-button>
      </base-card-template>
    </payment-template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import { copyToClipboard } from 'lib/utils/clipboard';

import BaseIcon from 'atoms/base/BaseIcon';
import SimpleButton from 'molecules/common/SimpleButton';
import BaseHeader from 'organisms/base/BaseHeader';
import BaseCardTemplate from 'templates/BaseCardTemplate';
import PaymentTemplate from 'templates/PaymentTemplate';

export default {
  name: 'FailedPayment',
  components: {
    BaseIcon,
    SimpleButton,
    BaseHeader,
    BaseCardTemplate,
    PaymentTemplate,
  },
  computed: {
    displayMessage() {
      return this.$t('operation.denied.support', { projectName: this.PROJECT.project_name });
    },
    transactionId() {
      if (this.$validate.isNotNull(this.TRANSACTION.partnerPaymentId)) {
        return this.TRANSACTION.partnerPaymentId;
      }

      return this.TRANSACTION.id;
    },
    ...mapState(['PROJECT', 'TRANSACTION']),
    ...mapGetters(['getLanguage', 'getRouteWithParamsByTransaction']),
  },
  methods: {
    handleCopy() {
      copyToClipboard(this.transactionId);

      this.$alert({
        type: 'info',
        title: 'rejected.transaction.id.copied',
      });
    },
    handleRedirect() {
      this.$router.push(this.getRouteWithParamsByTransaction);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +respond-to('medium')
      padding: 10px 0

  .image
    max-width: 120px
    max-height: 120px

  .information
    +flexbox
    +flex-direction(column)
    +align-items(center)
    margin-bottom: 20px

  .copy
    +flexbox
    +align-items(center)
    padding: 5px 10px
    border-radius: 5px
    background: #F6F6F6
    color: var(--color-violet)
    cursor: pointer
</style>
